// import Mock from 'mockjs'

// const mockData = Mock.mock({
//   'data|3-6': [{
//     'name': '@NAME',
//     'creatDate': '@DATE',
//     'address': '@CITY',
//     'zip': '@ZIP'
//   }]
// })

export default {
  data: null,
  columns: [
    {
      label: '加盟商名称',
      prop: 'orgName'
    },
    {
      label: '业务类型',
      prop: 'busType'
    },
    {
      label: '业务类别',
      prop: 'busCategory'
    },
    {
      label: '业务名称',
      prop: 'busName'
    },
    {
      label: '比赛场地',
      prop: 'placeName'
    },
    {
      label: '签位数',
      prop: '__applySize__' // 非接口传回，由本地计算所得
    },
    {
      label: '业务ID',
      prop: 'busCode'
    },
    {
      label: '业务状态',
      prop: 'busStatus'
    },
    {
      label: '开始时间',
      prop: 'busStartTime'
    },
    // {
    //   label: '缴费类型',
    //   prop: 'type'
    // },
    {
      label: '总收入(元)',
      prop: '__totalRevenue__' // 非接口传回，由本地计算所得
    },
    {
      label: '不含退款收入(元)',
      prop: 'totalAmount'
    },
    {
      label: '加盟费(元)',
      prop: 'totalFranchise'
    },
    {
      label: '未结加盟费(元)',
      prop: 'noFranchise'
    },
    {
      label: '退款余额(元)',
      prop: 'refundBalance'
    },
    {
      label: '退款余额度占比(%)',
      prop: '__proportion__' // 非接口传回，由本地计算所得
    },
    // {
    //   label: '退款金额(元)',
    //   prop: 'refundAmt'
    // },
    {
      label: '提现手续费(元)',
      prop: 'serviceFee'
    },
    // {
    //   label: '缴费状态',
    //   prop: 'status'
    // }
    {
      label: '联系人',
      prop: 'orgContactName'
    },
    {
      label: '联系电话',
      prop: 'orgContactPhone'
    },
  ]
}
